module.exports = require("handsontable/dist/handsontable.full.css");